// **********************************************************
// Product Gallery Modal
// **********************************************************

const productGalleryModalMain = document.querySelectorAll('[data-slider="product-gallery-modal-main-slider"]');
const productGalleryModalThumb = document.querySelectorAll('[data-slider="product-gallery-modal-thumb-slider"]');

const toggleProductGalleryModal = (element, toggle) => {
  const parentElement = element.closest('.product-gallery-modal');
  parentElement?.classList.toggle('is-open-modal', toggle);
  toggleBodyScrollLock(toggle);
};

// 1.1 - Product Gallery Thumb Slider
const productGalleryModalThumbSliderOptions = {
  direction: 'vertical',
  slidesPerView: 4,
  spaceBetween: 6,
  watchOverflow: true,
  mousewheel: true,
  scrollbar: {
    el: '.swiper-scrollbar',
    hide: false,
    draggable: true,
  },
  breakpoints: {
    1199: {
      slidesPerView: 5,
      spaceBetween: 6,
    },
  },
};

productGalleryModalThumb.forEach((ele) => {
  const thumbSlider = ele.closest('.product-gallery-modal__thumb');
  const scrollbar = thumbSlider.querySelector('.swiper-scrollbar');

  productGalleryModalThumbSliderOptions.scrollbar.el = scrollbar;

  new Swiper(ele, productGalleryModalThumbSliderOptions);
});

// 1.2 -Product Gallery Main Slider
const productGalleryModalMainOptions = {
  direction: 'vertical',
  slidesPerView: 'auto',
  spaceBetween: 60,
  grabCursor: true,
  simulateTouch: true,
  freeMode: true,
  mousewheel: true,
  thumbs: {
    swiper: false,
  },
  breakpoints: {
    1023: {
      slidesPerView: 'auto',
      spaceBetween: 80,
      freeMode: false,
    },
  },
};

productGalleryModalMain.forEach((el, i) => {
  productGalleryModalMainOptions.thumbs.swiper = productGalleryModalThumb[i].swiper;
  const productGalleryModalSlider = windowWidth() > breakpointMd && new Swiper(el, productGalleryModalMainOptions);

  attachEvent('[data-modal-slide]', 'click', (ev) => {
    const targetSlideEle = ev.target.closest('.product-showcase__image--main');
    const targetSlideAttr = targetSlideEle.getAttribute('data-modal-slide');
    const parentEle = targetSlideEle.closest('[product-gallery-parent]');
    const galleryModal = parentEle.querySelector('.product-gallery-modal');
    const slideIndex = targetSlideAttr - 1;

    if (galleryModal) {
      galleryModal.classList.add('is-open-modal');
      toggleBodyScrollLock(true);
    }

    if (windowWidth() > breakpointMd) {
      productGalleryModalSlider.slideTo(slideIndex, 0);
      return;
    }

    const modalSlides = parentEle.querySelectorAll('.product-gallery-modal__main .swiper-slide');
    const mobileTargetSlide = modalSlides[slideIndex];

    galleryModal.scrollTo({
      top: mobileTargetSlide.offsetTop,
      behavior: 'smooth',
    });
  });
});

// **********************************************************
// 1.3 Product Gallery Modal When Escape Key Press
// **********************************************************

onKeydown('escape', () => {
  document.querySelectorAll('.product-gallery-modal.is-open-modal').forEach((el) => {
    toggleProductGalleryModal(el, false);
  });
});

// **********************************************************
// 1.4 Product Gallery Modal When Click On Close
// **********************************************************

attachEvent('.product-gallery-modal__close', 'click', (ev) => {
  toggleProductGalleryModal(ev.target, false);
});
